import { render, staticRenderFns } from "./AcessoPortal.vue?vue&type=template&id=2c4805a7&scoped=true&"
import script from "./AcessoPortal.vue?vue&type=script&lang=js&"
export * from "./AcessoPortal.vue?vue&type=script&lang=js&"
import style0 from "./AcessoPortal.vue?vue&type=style&index=0&id=2c4805a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4805a7",
  null
  
)

export default component.exports